module.exports = __webpack_public_path__ + "static/media/embedded3.a34b8242.jpg";